import ox from '$/ox'
import $ from '$/jquery'

// TTM-263
// Add Dev/Staging banner at bottom right to indicate which is current environment
const tt = ox.serverConfig.talktalk
const ttEnv = ox.serverConfig.talktalk_environment

if (tt && ttEnv && String(ttEnv).trim().length > 0 && $('#tt-banner-bottom-right').length === 0) {
  $('#tt-banner-bottom-right').remove()
  const banner = $('<div id="tt-banner-bottom-right">').text(ttEnv)
  banner.appendTo(document.body)
}
